/* eslint-disable arrow-body-style */
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Box } from '@material-ui/core';

import { LoadTabGroup } from '../loading/LoadTabGroup';

Load.propTypes = {
  updateRack: PropTypes.func,
  rack: PropTypes.object,
  setLoadTabValue: PropTypes.func,
  loadTabValue: PropTypes.number,
  buildID: PropTypes.string,
  setBuildID: PropTypes.func,
  buildDetails: PropTypes.object,
  setBuildDetails: PropTypes.func
};

export default function Load({
  rack,
  updateRack,
  loadTabValue,
  setLoadTabValue,
  buildID,
  setBuildID,
  buildDetails,
  setBuildDetails
}) {
  const [kitList, setKitList] = useState(
    rack.kits
      ? rack.kits
      : {
          software: [],
          content: [],
          media: []
        }
  );
  const [componentsList, setComponentsList] = useState(
    rack.components
      ? rack.components
      : {
          software: [],
          content: [],
          onemedia: [],
          media: []
        }
  );

  useEffect(() => {
    // updates rack kit list when updated
    const rackCopy = { ...rack };
    rackCopy.kits = kitList;
    updateRack(rackCopy);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [kitList]);

  useEffect(() => {
    // updates rack components list when updated
    const rackCopy = { ...rack };
    rackCopy.components = componentsList;
    updateRack(rackCopy);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [componentsList]);

  return (
    <Box sx={{ width: '100%', padding: 4 }}>
      <LoadTabGroup
        rackName={rack.releaseName}
        systemType={rack.rack.systemType}
        buildID={buildID}
        setBuildID={setBuildID}
        buildDetails={buildDetails}
        setBuildDetails={setBuildDetails}
        kitList={kitList}
        setKitList={setKitList}
        componentsList={componentsList}
        setComponentsList={setComponentsList}
        tabValueRef={loadTabValue}
        setTabValueRef={setLoadTabValue}
        provision
      />
    </Box>
  );
}
